import {UserModel} from './user.model';

export interface UserAction {
  type: string;
  user?: UserModel;
  error?: string;
}

export class UserActions {

  static superadmins = ['k.gabara-extern@emetriq.com', 'a.mikeska-extern@emetriq.com'];

  static userSetLocalStorage(user: UserModel) {

    if (user.username && user.username.indexOf('emetriq.com') && !user.roles.includes('admin')) {
      user.roles.push('admin');
    }
    if (this.superadmins.includes(user.username)) {
      user.roles.push('superadmin');
    }
    localStorage.setItem('currentUser', JSON.stringify(user));
  }

  static userGetLocalStorage(): UserModel {
    return JSON.parse(localStorage.getItem('currentUser') as string) || {} as UserModel;
  }

}
